import React, { useEffect, useState, useRef, useMemo } from 'react';
import Select from 'react-select';
import CommissionFilters from '../components/filters/commissionfilter';
import { api } from '../services/api';
import { generateSummaryPdf,generateDetailedPdf,generateSummaryExcel, generateDetailedExcel } from '../services/commissionpdf';

const itemTypeOptions = [
  { value: 1, label: 'Service' },
  { value: 2, label: 'Retail' },
  { value: 3, label: 'Sundry' },
  { value: 5, label: 'Gift' },
  { value: 6, label: 'Series' },
  { value: 7, label: 'Membership' },
  { value: 8, label: 'Promotions'},
];

const emptyRule = {
  Name: '',
  EmployeeIds: [],
  Items: [
    {
      ItemType: null,
      CommissionMethod: 1,
      Percent: null,
      SlabDefinition: [],
      CategoryFilter: [],
      CompanyFilter: [],
      CategoryFilterOptions: [], // 🔹 add this
      CompanyFilterOptions: [], 
      SplitType: 1,
      SplitRatio: 50,
      SplitEnabled: false,   

      ApplyAllCategories: false,
      ApplyAllCompanies: false,
    }
  ],
  Active: 1,
};




const Commissions = () => {
  const [filters, setFilters] = useState({});
  const [summary, setSummary] = useState([]);
const [transactions, setTransactions] = useState([]);

  const [rules, setRules] = useState([]);
  const [employees, setEmployees] = useState([]);

  const [showRuleModal, setShowRuleModal] = useState(false);
  const [editingRule, setEditingRule] = useState(null);
  const [ruleForm, setRuleForm] = useState(emptyRule);
  const [modalMode, setModalMode] = useState('add'); // 'add' | 'edit' | 'manage'
  const [expandedEmployeeId, setExpandedEmployeeId] = useState(null);
  const [expandedFilters, setExpandedFilters] = useState({});
  const [showInactiveRules, setShowInactiveRules] = useState(false);
  const [showExportMenu, setShowExportMenu] = useState(false);
  const exportMenuRef = useRef(null);
  const [serviceCategories, setServiceCategories] = useState([]);
const [retailCompanies, setRetailCompanies] = useState([]);
const [validationErrors, setValidationErrors] = useState({});

const [showOperatorsInline, setShowOperatorsInline] = useState(false);
const [expandedOperators, setExpandedOperators] = useState({});
const [loading, setLoading] = useState(false);
const [categorySearch, setCategorySearch] = useState({});
const [companySearch, setCompanySearch] = useState({});
const [searchTerm, setSearchTerm] = useState('');





const toggleOperator = (operatorName) => {
  setExpandedOperators(prev => ({
    ...prev,
    [operatorName]: !prev[operatorName]
  }));
};

// const membershipCategoriesInRule = useMemo(() => {
//     return (ruleForm.Items || [])
//       .filter(i => i.ItemType === 7)
//       .flatMap(i => i.CategoryFilter || []);
//   }, [ruleForm.Items]);

  const serviceDerivedCategoriesInRule = useMemo(() => {
  return (ruleForm.Items || [])
    .filter(i => [7, 8].includes(i.ItemType))
    .flatMap(i => i.CategoryFilter || []);
}, [ruleForm.Items]);



// const serviceCategoriesInRule = useMemo(() => {
//   return (ruleForm.Items || [])
//     .filter(i => i.ItemType === 1)
//     .flatMap(i => i.CategoryFilter || []);
// }, [ruleForm.Items]);



const loadRules = async (includeInactive = false) => {
  const res = await api.get('/commission', {
    params: { includeInactive }
  });
  setRules(res.data);
};
const calculateCommissions = async () => {
  if (!filters.from || !filters.to) return;

  try {
    setLoading(true);
    const res = await api.post('/commission/calculate', {
      fromDate: filters.from,
      toDate: filters.to,
      itemType: filters.itemType,
      employeeId: filters.employeeId,
    });

    setSummary(res.data.summary || []);
    setTransactions(res.data.transactions || []);
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

  // Fetch all rules once
  useEffect(() => {
  loadRules(showInactiveRules);
}, [showInactiveRules]);
useEffect(() => {
  setExpandedFilters({});
  setExpandedEmployeeId(null);
}, [rules]);

useEffect(() => {
  function handleClickOutside(event) {
    if (
      exportMenuRef.current &&
      !exportMenuRef.current.contains(event.target)
    ) {
      setShowExportMenu(false);
    }
  }

  if (showExportMenu) {
    document.addEventListener('mousedown', handleClickOutside);
  }

  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [showExportMenu]);


const loadEmployees = async (ruleId = null) => {
  const url = ruleId
    ? `/commission/employee?ruleId=${ruleId}`
    : `/commission/employee`;

  const res = await api.get(url);
  setEmployees(res.data);
};



  // Calculate commissions whenever filters change
useEffect(() => {
  calculateCommissions();
}, [filters]);

// fetch once
useEffect(() => {
  
  api.get('/commission/companies').then(r => setRetailCompanies(r.data));
}, []);

const fetchCategoriesForItemType = async (itemType, ruleId, currentSelectedCategories = []) => {
  try {
    const res = await api.get('/commission/categories', {
      params: { 
        itemType,
        ruleId,
        exclude: currentSelectedCategories.join(',') // pass comma-separated
      }
    });
    return res.data || [];
  } catch (err) {
    console.error('Failed to load categories for itemType', itemType, err);
    return [];
  }
};




useEffect(() => {
  if (
    modalMode !== 'add' ||
    !ruleForm.Items?.length ||
    !serviceCategories.length ||
    !retailCompanies.length
  ) return;

  setRuleForm(prev => ({
    ...prev,
    Items: prev.Items.map(item => ({
      ...item,
      CategoryFilterOptions: serviceCategories,
      CompanyFilterOptions: retailCompanies,
    }))
  }));
}, [serviceCategories, retailCompanies, modalMode]);








const openAddRuleModal = async () => {
  setValidationErrors({});
  await loadEmployees();
  const itemsWithCategories = await Promise.all(
    emptyRule.Items.map(async (item) => ({
      ...item,
      CategoryFilterOptions: await fetchCategoriesForItemType(item.ItemType),
      CompanyFilterOptions: retailCompanies,
    }))
  );
  

  setRuleForm({
    ...emptyRule,
    Items: itemsWithCategories
  });

  setEditingRule(null);
  setModalMode('add');
  setShowRuleModal(true);
};


  const openEditRulesModal = async () => {
  await loadRules(showInactiveRules);
  setModalMode('manage');
  setShowRuleModal(true);
};

const openEditRuleModal = async (rule) => {
  setValidationErrors({});
  const res = await api.get(`/commission/${rule.CommissionRuleId}`);
  const fullRule = res.data;
  await loadEmployees(fullRule.CommissionRuleId);
  const items = await Promise.all(
    (fullRule.Items || []).map(async (item) => {
      const isServiceOrMembership =
  item.ItemType === 1 || item.ItemType === 7 || item.ItemType === 8;


      // 🔹 Collect categories from other items in the same rule
      const excludeCategories = (fullRule.Items || [])
        .filter(it =>
  it.CommissionRuleItemId !== item.CommissionRuleItemId &&
  !(
    [7, 8].includes(it.ItemType) &&
    [7, 8].includes(item.ItemType)
  )
)

        .flatMap(it => it.CategoryFilter || []);


        const companyOptions = item.ItemType === 2 ? retailCompanies : [];

const applyAllCompanies =
  item.ApplyAllCompanies === true ||
  !item.CompanyFilter ||
  item.CompanyFilter.length === 0;

const companyFilter =
  applyAllCompanies
    ? companyOptions.map(c => c.value)
    : (item.CompanyFilter || []);

      

      const categoryOptions = isServiceOrMembership
        ? await fetchCategoriesForItemType(item.ItemType, fullRule.CommissionRuleId, excludeCategories)
        : [];
        const isService = item.ItemType === 1;
        const isMembershipOrPromotion = [7, 8].includes(item.ItemType);

      return {
        ...item,
        ApplyAllCategories:
  isService && (!item.CategoryFilter || item.CategoryFilter.length === 0),
        ApplyAllCompanies: applyAllCompanies,
        ApplyAllEmployees: !item.EmployeeIds || item.EmployeeIds.length === 0,
        CategoryFilter: item.CategoryFilter || [],
        CompanyFilter: companyFilter,
        CategoryFilterOptions: categoryOptions,
        CompanyFilterOptions: companyOptions,
        SplitEnabled: Boolean(item.SplitEnabled),
        SplitRatio: Number(item.SplitRatio ?? 50),
      };
    })
  );


  setEditingRule(fullRule);
  setRuleForm({
    ...fullRule,
    Items: items,
    EmployeeIds: fullRule.EmployeeIds || [],
  });

  setModalMode('edit');
  setShowRuleModal(true);
};


const validateSlabs = (slabs, itemIndex, errors) => {
  if (!slabs || slabs.length === 0) {
    errors[`Items.${itemIndex}.SlabDefinition`] = 'At least one slab is required';
    return;
  }

  for (let i = 0; i < slabs.length; i++) {
    const slab = slabs[i];

    if (slab.Min === '' || slab.Max === '' || slab.Percent === '') {
      errors[`Items.${itemIndex}.SlabDefinition`] =
        'All slab fields (Min, Max, Percent) are required';
      return;
    }

    if (slab.Min < 0) {
      errors[`Items.${itemIndex}.SlabDefinition`] = 'Min amount cannot be negative';
      return;
    }

    if (slab.Max <= slab.Min) {
      errors[`Items.${itemIndex}.SlabDefinition`] =
        'Max amount must be greater than Min amount';
      return;
    }

    if (slab.Percent <= 0) {
      errors[`Items.${itemIndex}.SlabDefinition`] =
        'Commission percent must be greater than 0';
      return;
    }

    // Check continuity
    if (i > 0) {
      const prev = slabs[i - 1];
      if (slab.Min !== prev.Max + 1) {
        errors[`Items.${itemIndex}.SlabDefinition`] =
          'Slabs must be continuous without gaps or overlaps';
        return;
      }
    }
  }
};
const scrollToFirstError = (errors) => {
  const firstKey = Object.keys(errors)[0];
  if (!firstKey) return;

  const el = document.querySelector(
    `[data-error-key="${firstKey}"]`
  );

  if (el) {
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
    el.focus?.();
  }
};



const serviceCategoriesInRule = ruleForm.Items
  .filter(i => i.ItemType === 1)
  .flatMap(i => i.CategoryFilter || []);

const membershipCategoriesInRule = ruleForm.Items
  .filter(i => i.ItemType === 7)
  .flatMap(i => i.CategoryFilter || []);

const promotionCategoriesInRule = ruleForm.Items
  .filter(i => i.ItemType === 8)
  .flatMap(i => i.CategoryFilter || []);






 const saveRule = async () => {
  const errors = {};
  

  // Rule Name required
  if (!ruleForm.Name.trim()) {
    errors.Name = 'Rule name is required';
  }
  if (!ruleForm.EmployeeIds || ruleForm.EmployeeIds.length === 0) {
  errors.EmployeeIds = 'Select at least one employee';
}

  // Validate each item
  ruleForm.Items.forEach((item, idx) => {
    if (!item.ItemType) {
      errors[`Items.${idx}.ItemType`] = 'Item type is required';
    }
    if (
      item.CommissionMethod === 1 &&
      (item.Percent == null || item.Percent === '' || item.Percent <= 0)
    ) {
      errors[`Items.${idx}.Percent`] = 'Commission percent must be greater than 0';
    }

    if (item.CommissionMethod === 2) {
  validateSlabs(item.SlabDefinition, idx, errors);
}


    if (item.SplitEnabled && (item.SplitRatio === '' || item.SplitRatio == null)) {
      errors[`Items.${idx}.SplitRatio`] = 'Split ratio is required';
    }
    // CATEGORY VALIDATION
if (item.ItemType === 1) {
  // Service
  if (!item.ApplyAllCategories && (!item.CategoryFilter || item.CategoryFilter.length === 0)) {
    errors[`Items.${idx}.CategoryFilter`] = 'Please select at least one service category';
  }
}

if ([7, 8].includes(item.ItemType)) {
  if (!item.CategoryFilter || item.CategoryFilter.length === 0) {
    errors[`Items.${idx}.CategoryFilter`] =
      'Please select at least one category';
  }
}


// COMPANY VALIDATION
if (item.ItemType === 2) {
  // Retail
  if (!item.ApplyAllCompanies && (!item.CompanyFilter || item.CompanyFilter.length === 0)) {
    errors[`Items.${idx}.CompanyFilter`] = 'Please select at least one retail company';
  }
}


  });

  if (Object.keys(errors).length > 0) {
    setValidationErrors(errors);
    scrollToFirstError(errors);
    return; // stop submission
  }

  // Clear previous errors
  setValidationErrors({});
  

  // Continue to send payload
  const payload = {
    Name: ruleForm.Name,
    Active: ruleForm.Active,
    EmployeeIds: ruleForm.EmployeeIds,
    Items: ruleForm.Items.map(item => {
  const applyAllCategories = Boolean(item.ApplyAllCategories);
  const applyAllCompanies = Boolean(item.ApplyAllCompanies);


  return {
    ItemType: item.ItemType,
    CommissionMethod: item.CommissionMethod,

    Percent:
  item.CommissionMethod === 1
    ? Number(item.Percent)
    : null,


    SlabDefinition:
  [2, 3].includes(item.CommissionMethod)
    ? item.SlabDefinition
    : null,


    // 🔥 CATEGORY FIX
    ApplyAllCategories: applyAllCategories,
    CategoryFilter: applyAllCategories
      ? null
      : (item.CategoryFilter || []),

    // 🔥 COMPANY FIX
    ApplyAllCompanies: applyAllCompanies,
    CompanyFilter: applyAllCompanies
      ? null
      : (item.CompanyFilter || []),

   

    SplitType: item.SplitType ?? 1,
    SplitRatio: Number(item.SplitRatio ?? 50),
    SplitEnabled: Boolean(item.SplitEnabled)
  };
})


  };

   // 🔍 🔍 ADD THIS BLOCK HERE 🔍 🔍
  // // console.log('FINAL PAYLOAD BEING SENT:');
  // // payload.Items.forEach((item, idx) => {
  // //   console.log(
  // //     `Item[${idx}]`,
  // //     {
  // //       ItemType: item.ItemType,
  // //       CommissionMethod: item.CommissionMethod,
  // //       SlabDefinition: item.SlabDefinition
  // //     }
  // //   );
  // });

  if (editingRule && editingRule.Active === 0) {
    alert('Please restore the rule before editing it.');
    return;
  }

  if (editingRule) {
    await api.put(`/commission/${editingRule.CommissionRuleId}`, payload);
  } else {
    await api.post('/commission', payload);
  }

  // setShowRuleModal(false);
  await loadRules(showInactiveRules);
  await calculateCommissions();
  // switch back to Manage view
setModalMode('manage');
setEditingRule(null);
};


 const addSlab = (itemIndex) => {
  const items = [...ruleForm.Items];
  const item = { ...items[itemIndex] };

  const slabs = [...(item.SlabDefinition || [])];

  let newMin = 0;

  if (slabs.length > 0) {
    const lastSlab = slabs[slabs.length - 1];

    // Prevent adding if last slab is incomplete
    if (lastSlab.Max == null || lastSlab.Max === '') {
      alert('Please enter Max value for the previous slab first');
      return;
    }

    newMin = Number(lastSlab.Max) + 1;
  }

  slabs.push({
    Min: newMin,
    Max: '',
    Percent: ''
  });

  item.SlabDefinition = slabs;
  items[itemIndex] = item;

  setRuleForm({ ...ruleForm, Items: items });
};



  const updateSlab = (itemIndex, slabIndex, key, value) => {
  const items = [...ruleForm.Items];
  const item = { ...items[itemIndex] };
  const slabs = [...(item.SlabDefinition || [])];

  slabs[slabIndex][key] =
    value === '' ? '' : Number(value);

  item.SlabDefinition = slabs;
  items[itemIndex] = item;

  setRuleForm({ ...ruleForm, Items: items });
};


  const toggleExpand = (employeeId) => {
  setExpandedEmployeeId(prev => {
    const nextId = prev === employeeId ? null : employeeId;
    if (nextId && !expandedFilters[nextId]) {
      setExpandedFilters(prev => ({
        ...prev,
        [nextId]: { ruleId: null, company: null, category: null }
      }));
    }
    return nextId;
  });
};

const deactivateRule = async (rule) => {
  await api.delete(`/commission/${rule.CommissionRuleId}`);
  await loadRules(showInactiveRules);
  await calculateCommissions(); // 🔥 THIS fixes stale data
};

const restoreRule = async (rule) => {
  await api.put(`/commission/${rule.CommissionRuleId}/restore`);
  await loadRules(showInactiveRules);
  await calculateCommissions(); // 🔥
};
const hardDeleteRule = async (rule) => {
  
  try {
    await api.delete(`/commission/${rule.CommissionRuleId}/hard`);
    await loadRules(showInactiveRules);
    await calculateCommissions();
  } catch (err) {
    alert(err.response?.data?.message || 'Failed to hard delete rule');
  }
};

const formatCommissionType = (t) => {
  const method = Number(t.CommissionMethod);

  let slabs = t.CommissionSlabs;

  // ✅ FIX: parse if string
  if (typeof slabs === 'string') {
    try {
      slabs = JSON.parse(slabs);
    } catch {
      slabs = null;
    }
  }

  if (method === 1) {
    return `Flat (${t.CommissionPercent}%)`;
  }

  if (method === 2 && Array.isArray(slabs)) {
    return `Progressive: ` + slabs
      .map(s => `${s.Min ?? 0}–${s.Max ?? '∞'} @ ${s.Percent}%`)
      .join(', ');
  }

  if (method === 3 && Array.isArray(slabs)) {
    return `Jump: ` + slabs
      .map(s => `${s.Min ?? 0}–${s.Max ?? '∞'} @ ${s.Percent}%`)
      .join(', ');
  }

  return '—';
};
const removeLastSlab = (itemIndex) => {
  const items = [...ruleForm.Items];
  const item = { ...items[itemIndex] };

  const slabs = [...(item.SlabDefinition || [])];

  if (slabs.length <= 1) {
    return; // keep at least one slab
  }

  slabs.pop(); // remove only last slab
  item.SlabDefinition = slabs;

  items[itemIndex] = item;
  setRuleForm({ ...ruleForm, Items: items });
};
const usedItemTypes = ruleForm.Items
  .map(i => i.ItemType)
  .filter(v => v != null);

const availableItemTypes = itemTypeOptions.filter(
  opt => !usedItemTypes.includes(opt.value)
);
const hasUnconfiguredItem = ruleForm.Items.some(
  i => i.ItemType == null
);


const canAddMoreItems =
  availableItemTypes.length > 0 && !hasUnconfiguredItem;

  const hasSummaryData = Array.isArray(summary) && summary.length > 0;
const hasTransactionData = Array.isArray(transactions) && transactions.length > 0;

const canExport = !loading && hasSummaryData && hasTransactionData;


const filteredRules = rules.filter(rule => {
  const matchesSearch =
    rule.Name?.toLowerCase().includes(searchTerm.toLowerCase());

  const matchesActiveFilter =
    showInactiveRules ? true : rule.Active;

  return matchesSearch && matchesActiveFilter;
});

useEffect(() => {
  if (!showRuleModal) {
    setSearchTerm('');
  }
}, [showRuleModal]);


const formatMoney = (value) => {
  if (value == null) return '0.00';

  const truncated = Math.trunc(value * 100) / 100;

  return truncated.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};



  return (
 <div className="p-6">
  <CommissionFilters filters={filters} setFilters={setFilters} />

  {/* Action Buttons */}
  <div className="flex flex-wrap justify-end mb-6 gap-3">
   {/* Export Dropdown */}
<div className="relative" ref={exportMenuRef}>
  <button
    disabled={!canExport}
    onClick={() => setShowExportMenu(v => !v)}
    className={`
      px-6 py-3 font-bold rounded-lg shadow-lg flex items-center gap-2.5
      transition-all duration-200
      ${canExport
        ? 'bg-gradient-to-r from-emerald-500 to-green-600 text-white hover:shadow-xl hover:scale-105 active:scale-100'
        : 'bg-slate-300 text-slate-500 cursor-not-allowed'}
    `}
  >
    <span className="text-xl">⬇</span>
    <span>Export</span>
    <span className={`ml-auto transition-transform duration-300 ${showExportMenu ? 'rotate-180' : 'rotate-0'}`}>
      ▾
    </span>
  </button>

  {showExportMenu && (
    <div className="absolute right-0 mt-3 w-64 bg-white border-2 border-slate-200 rounded-xl shadow-2xl z-50 overflow-hidden animate-fadeIn">
      
      {/* Header */}
      <div className="px-4 py-2.5 bg-gradient-to-r from-emerald-50 to-green-50 border-b-2 border-emerald-200">
        <h3 className="text-xs font-bold text-emerald-800 uppercase tracking-wide">
          Export Options
        </h3>
      </div>

      {/* Export Options */}
      <div className="py-1.5">
        {/* Summary PDF */}
        <button
          onClick={() => {
            setShowExportMenu(false);
            const pdfSummary = summary.map(s => {
              const employeeTx = transactions.filter(t => t.OriginalEmployeeId === s.EmployeeId);
              const totals = employeeTx.reduce((acc, t) => {
                acc.totalSales += t.TotalSalesExTax || 0;
                acc.totalCommission += t.CommissionAmount || 0;
                if (t.Role === 'Stylist') acc.stylist += t.CommissionAmount || 0;
                if (t.Role === 'Operator') {
                  if (!acc.operators[t.EmployeeId]) {
                    acc.operators[t.EmployeeId] = {
                      EmployeeId: t.EmployeeId,
                      EmployeeName: t.EmployeeName,
                      amount: 0
                    };
                  }
                  acc.operators[t.EmployeeId].amount += t.CommissionAmount || 0;
                }
                return acc;
              }, { totalSales: 0, totalCommission: 0, stylist: 0, operators: {} });

              return {
                EmployeeId: s.EmployeeId,
                EmployeeName: s.EmployeeName,
                TotalSalesExTax: s.TotalSalesExTax,
                StylistCommission: totals.stylist,
                TotalCommission: totals.totalCommission,
                Operators: Object.values(totals.operators).map(data => ({
                  EmployeeId: data.EmployeeId,
                  EmployeeName: data.EmployeeName,
                  TotalCommission: data.amount
                }))
              };
            });
            generateSummaryPdf({ summary: pdfSummary, transactions, filters });
          }}
          className="w-full px-4 py-3 text-left hover:bg-red-50 transition-all duration-200 flex items-center gap-2.5 group"
        >
          <span className="text-xl group-hover:scale-110 transition-transform">📄</span>
          <div className="flex-1">
            <div className="text-sm font-semibold text-slate-800 group-hover:text-red-700">Summary PDF</div>
            <p className="text-xs text-slate-500">Commission overview</p>
          </div>
        </button>

        <div className="h-px bg-slate-100 mx-3"></div>

        {/* Summary Excel */}
        <button
          onClick={() => {
            setShowExportMenu(false);
            const excelSummary = summary.map(s => {
              const employeeTx = transactions.filter(t => t.OriginalEmployeeId === s.EmployeeId);
              const totals = employeeTx.reduce((acc, t) => {
                acc.totalSales += t.TotalSalesExTax || 0;
                acc.totalCommission += t.CommissionAmount || 0;
                if (t.Role === 'Stylist') acc.stylist += t.CommissionAmount || 0;
                if (t.Role === 'Operator') {
                  if (!acc.operators[t.EmployeeId]) {
                    acc.operators[t.EmployeeId] = {
                      EmployeeId: t.EmployeeId,
                      EmployeeName: t.EmployeeName,
                      amount: 0
                    };
                  }
                  acc.operators[t.EmployeeId].amount += t.CommissionAmount || 0;
                }
                return acc;
              }, { totalSales: 0, totalCommission: 0, stylist: 0, operators: {} });

              return {
                EmployeeId: s.EmployeeId,
                EmployeeName: s.EmployeeName,
                TotalSalesExTax: s.TotalSalesExTax,
                StylistCommission: totals.stylist,
                TotalCommission: totals.totalCommission,
                Operators: Object.values(totals.operators).map(data => ({
                  EmployeeId: data.EmployeeId,
                  EmployeeName: data.EmployeeName,
                  TotalCommission: data.amount
                }))
              };
            });
            generateSummaryExcel({ summary: excelSummary, transactions, filters });
          }}
          className="w-full px-4 py-3 text-left hover:bg-green-50 transition-all duration-200 flex items-center gap-2.5 group"
        >
          <span className="text-xl group-hover:scale-110 transition-transform">📊</span>
          <div className="flex-1">
            <div className="text-sm font-semibold text-slate-800 group-hover:text-green-700">Summary Excel</div>
            <p className="text-xs text-slate-500">Totals spreadsheet</p>
          </div>
        </button>

        <div className="h-px bg-slate-200 mx-3 my-1.5"></div>

        {/* Detailed PDF */}
        <button
          onClick={() => {
            setShowExportMenu(false);
            generateDetailedPdf({ summary, transactions, expandedEmployeeId, expandedFilters, filters });
          }}
          className="w-full px-4 py-3 text-left hover:bg-blue-50 transition-all duration-200 flex items-center gap-2.5 group"
        >
          <span className="text-xl group-hover:scale-110 transition-transform">📑</span>
          <div className="flex-1">
            <div className="text-sm font-semibold text-slate-800 group-hover:text-blue-700">Detailed PDF</div>
            <p className="text-xs text-slate-500">Transaction breakdown</p>
          </div>
        </button>

        <div className="h-px bg-slate-100 mx-3"></div>

        {/* Detailed Excel */}
        <button
          onClick={() => {
            setShowExportMenu(false);
            generateDetailedExcel({ summary, transactions, expandedEmployeeId, expandedFilters, filters });
          }}
          className="w-full px-4 py-3 text-left hover:bg-indigo-50 transition-all duration-200 flex items-center gap-2.5 group"
        >
          <span className="text-xl group-hover:scale-110 transition-transform">📈</span>
          <div className="flex-1">
            <div className="text-sm font-semibold text-slate-800 group-hover:text-indigo-700">Detailed Excel</div>
            <p className="text-xs text-slate-500">Full data columns</p>
          </div>
        </button>
      </div>

    </div>
  )}
</div>

    <button
      onClick={openAddRuleModal}
      className="px-6 py-3 bg-gradient-to-r from-cyan-500 to-blue-500 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-200 flex items-center gap-2"
    >
      <span className="text-xl">+</span> Add Rule
    </button>

    <button
      onClick={openEditRulesModal}
      className="px-6 py-3 bg-gradient-to-r from-indigo-500 to-purple-500 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-200 flex items-center gap-2"
    >
      ✏️ Edit Rules
    </button>
  </div>

  {/* Commissions Table */}
  <div className="bg-white shadow-lg rounded-xl overflow-hidden">
    <table className="min-w-full">
      <thead>
        <tr className="bg-gradient-to-r from-slate-50 to-slate-100 border-b-2 border-slate-200">
          <th className="px-6 py-4 text-left text-sm font-semibold text-slate-600 uppercase tracking-wide">Employee</th>
          <th className="px-6 py-4 text-left text-sm font-semibold text-slate-600 uppercase tracking-wide">Item Type</th>
          <th className="px-6 py-4 text-left text-sm font-semibold text-slate-600 uppercase tracking-wide">Total Sales</th>
          <th className="px-6 py-4 text-left text-sm font-semibold text-slate-600 uppercase tracking-wide">Commission</th>
        </tr>
      </thead>

      <tbody>
        {loading ? (
            <tr>
              <td colSpan={4} className="text-center py-16">
                <div className="flex flex-col items-center justify-center">

                  {/* Spinner */}
                  <div className="w-12 h-12 border-4 border-cyan-200 border-t-cyan-600 rounded-full animate-spin mb-4"></div>

                  <h3 className="text-lg font-semibold text-slate-700">
                    Loading commissions...
                  </h3>

                  <p className="text-slate-500 text-sm">
                    Please wait while data is being fetched
                  </p>

                </div>
              </td>
            </tr>

          ) : summary.length === 0 ? (
          <tr>
            <td colSpan={4} className="text-center py-12">
              <div className="text-6xl mb-4">💰</div>

              <h3 className="text-xl font-semibold text-slate-700 mb-2">
                No Commissions
              </h3>

              <p className="text-slate-500 mb-4">
                No commission data available for the selected period
              </p>

              <p className="text-sm text-slate-400 italic">
                Note: All commissions are calculated on pre-tax (exclusive of tax) amounts.
              </p>
            </td>
          </tr>
        ) : (
          summary.map((s, idx) => (
            <React.Fragment key={s.EmployeeId}>
              {/* Summary Row */}
              <tr
                onClick={() => toggleExpand(s.EmployeeId)}
                className={`cursor-pointer transition-all duration-150 ${
                  idx % 2 === 0 ? 'bg-white' : 'bg-slate-50'
                } hover:bg-gradient-to-r hover:from-cyan-50 hover:to-blue-50 border-b border-slate-100`}
              >
                <td className="px-6 py-4 font-semibold text-slate-800">
                  <div className="flex items-center gap-2">
                    <span className={`transition-transform duration-200 text-cyan-600 ${expandedEmployeeId === s.EmployeeId ? 'rotate-90' : ''}`}>
                      ▶
                    </span>
                    {s.EmployeeName}
                  </div>
                </td>
                <td className="px-6 py-4 text-slate-600">
                  {[...new Set(transactions.filter(t => t.OriginalEmployeeId === s.EmployeeId).map(t => t.ItemType))]
                    .map(t => itemTypeOptions.find(o => o.value === t)?.label ?? 'Other').join(', ')}
                </td>
                <td className="px-6 py-4 font-medium text-slate-700">{formatMoney(s.TotalSalesExTax)}</td>
                <td className="px-6 py-4">
                  <span className="px-3 py-1 bg-gradient-to-r from-green-500 to-emerald-500 text-white font-bold rounded-lg shadow-sm">
                    {formatMoney(s.TotalCommission)}
                  </span>
                </td>
              </tr>

              {/* Expandable Detail Row */}
              {expandedEmployeeId === s.EmployeeId && (
                <tr>
                  <td colSpan={4} className="bg-gradient-to-br from-slate-50 to-slate-100 px-6 py-6">
                    
                    {/* Toggle Checkbox */}
                    <div className="mb-4 p-3 bg-white rounded-lg border-2 border-cyan-200 shadow-sm">
                      <label className="flex items-center gap-3 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={showOperatorsInline}
                          onChange={e => {
                            setShowOperatorsInline(e.target.checked);
                            setExpandedFilters(prev => ({
                              ...prev,
                              [s.EmployeeId]: { ...prev[s.EmployeeId], operator: null }
                            }));
                          }}
                          className="w-5 h-5 text-cyan-600 rounded focus:ring-2 focus:ring-cyan-400"
                        />
                        <div>
                          <span className="text-sm font-semibold text-slate-800">Show operators inline with transactions</span>
                          <p className="text-xs text-slate-500">Display operator commissions within the transaction table</p>
                        </div>
                      </label>
                    </div>

                    {/* Filter Controls */}
                    <div className="grid grid-cols-1 md:grid-cols-5 gap-3 mb-4">
                      {/* <div>
                        <label className="block text-xs font-semibold text-slate-600 mb-1 uppercase tracking-wide">Rule</label>
                        <Select
                          options={rules
                            .filter(r => r.Active && r.EmployeeIds.includes(s.EmployeeId))
                            .map(r => ({ value: r.CommissionRuleId, label: r.Name }))
                          }
                          placeholder="Select Rule"
                          value={expandedFilters[s.EmployeeId]?.ruleId ? { 
                            value: expandedFilters[s.EmployeeId].ruleId, 
                            label: rules.find(r => r.CommissionRuleId === expandedFilters[s.EmployeeId].ruleId)?.Name 
                          } : null}
                          onChange={sel => setExpandedFilters(prev => ({
                            ...prev,
                            [s.EmployeeId]: { ...prev[s.EmployeeId], ruleId: sel?.value || null }
                          }))}
                          styles={{
                            control: base => ({ ...base, borderColor: '#cbd5e1', boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)', backgroundColor: 'white' }),
                            option: (base, state) => ({ ...base, backgroundColor: state.isSelected ? '#06b6d4' : state.isFocused ? '#ecfeff' : 'white' }),
                          }}
                        />
                      </div> */}

                      <div>
                        <label className="block text-xs font-semibold text-slate-600 mb-1 uppercase tracking-wide">Company</label>
                        <Select
                          options={[...new Set(transactions.filter(t => t.OriginalEmployeeId === s.EmployeeId && t.ItemType === 2).map(t => t.ItemName))].map(c => ({ value: c, label: c }))}
                          placeholder="Select Company"
                          value={expandedFilters[s.EmployeeId]?.company ? { 
                            value: expandedFilters[s.EmployeeId].company, 
                            label: expandedFilters[s.EmployeeId].company 
                          } : null}
                          onChange={sel => setExpandedFilters(prev => ({
                            ...prev,
                            [s.EmployeeId]: { ...prev[s.EmployeeId], company: sel?.value || null }
                          }))}
                          styles={{
                            control: base => ({ ...base, borderColor: '#cbd5e1', boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)', backgroundColor: 'white' }),
                            option: (base, state) => ({ ...base, backgroundColor: state.isSelected ? '#06b6d4' : state.isFocused ? '#ecfeff' : 'white' }),
                          }}
                        />
                      </div>

                      <div>
                        <label className="block text-xs font-semibold text-slate-600 mb-1 uppercase tracking-wide">Category</label>
                        
                        {(() => {
                          // 🔹 Calculate category options for this employee
                          const categoryOptions = [
                            ...new Set(
                              transactions
                                .filter(t => t.OriginalEmployeeId === s.EmployeeId)           // only this employee
                                .filter(t => t.ItemType === 1 || t.ItemType === 7 || t.ItemType === 8)             // Service OR Membership
                                .filter(t => 
                                  !expandedFilters[s.EmployeeId]?.ruleId || 
                                  t.CommissionRuleId === expandedFilters[s.EmployeeId].ruleId  // optional: filter by selected rule
                                )
                                .map(t => t.ItemName)
                            )
                          ].map(c => ({ value: c, label: c }));

                          return (
                            <Select
                              options={categoryOptions}
                              placeholder="Select Category"
                              value={expandedFilters[s.EmployeeId]?.category ? { 
                                value: expandedFilters[s.EmployeeId].category, 
                                label: expandedFilters[s.EmployeeId].category 
                              } : null}
                              onChange={sel => setExpandedFilters(prev => ({
                                ...prev,
                                [s.EmployeeId]: { ...prev[s.EmployeeId], category: sel?.value || null }
                              }))}
                              styles={{
                                control: base => ({ 
                                  ...base, 
                                  borderColor: '#cbd5e1', 
                                  boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)', 
                                  backgroundColor: 'white' 
                                }),
                                option: (base, state) => ({ 
                                  ...base, 
                                  backgroundColor: state.isSelected ? '#06b6d4' : state.isFocused ? '#ecfeff' : 'white' 
                                }),
                              }}
                            />
                          )
                        })()}
                      </div>


                      <div>
                        <label className="block text-xs font-semibold text-slate-600 mb-1 uppercase tracking-wide">Operator</label>
                        <Select
                          options={[...new Set(transactions.filter(t => t.OriginalEmployeeId === s.EmployeeId && t.Role === 'Operator').map(t => t.EmployeeName))].map(o => ({ value: o, label: o }))}
                          placeholder="Select Operator"
                          value={expandedFilters[s.EmployeeId]?.operator ? { 
                            value: expandedFilters[s.EmployeeId].operator, 
                            label: expandedFilters[s.EmployeeId].operator 
                          } : null}
                          onChange={sel => setExpandedFilters(prev => ({
                            ...prev,
                            [s.EmployeeId]: { ...prev[s.EmployeeId], operator: sel?.value || null }
                          }))}
                          styles={{
                            control: base => ({ ...base, borderColor: '#cbd5e1', boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)', backgroundColor: 'white' }),
                            option: (base, state) => ({ ...base, backgroundColor: state.isSelected ? '#06b6d4' : state.isFocused ? '#ecfeff' : 'white' }),
                          }}
                        />
                      </div>

                      <div className="flex items-end">
                        <button
                          onClick={() => setExpandedFilters(prev => ({
                            ...prev,
                            [s.EmployeeId]: { ruleId: null, company: null, category: null, operator: null }
                          }))}
                          className="w-full px-4 py-2.5 bg-gradient-to-r from-red-500 to-pink-500 text-white font-medium rounded-lg hover:shadow-lg transition-all duration-200 hover:scale-105"
                        >
                          🗑️ Clear
                        </button>
                      </div>
                    </div>

                    {/* Transactions Table */}
                    {(() => {
                      const f = expandedFilters[s.EmployeeId] || {};
                      const baseFiltered = transactions
                        .filter(t => t.OriginalEmployeeId === s.EmployeeId)
                        .filter(t => {
                          if (f.ruleId && t.CommissionRuleId !== f.ruleId) return false;
                          if (f.company && t.ItemType === 2 && t.ItemName !== f.company) return false;
                          if (
                            f.category &&
                            [1, 7, 8].includes(t.ItemType) &&
                            t.ItemName !== f.category
                          ) return false;

                          return true;
                        });
                        

                      const filteredTransactions = baseFiltered.reduce((acc, t) => {
                        if (f.operator) {
                          const saleHasOperator = baseFiltered.some(x => x.SaleID === t.SaleID && x.Role === 'Operator' && x.EmployeeName === f.operator);
                          if (!saleHasOperator) return acc;
                        }
                        acc.push(t);
                        return acc;
                      }, []);

                      const totals = filteredTransactions.reduce((acc, t) => {
                        acc.totalSales += t.TotalSalesExTax;
                        acc.totalCommission += t.CommissionAmount;
                        if (t.Role === 'Stylist') acc.stylist[t.EmployeeName] = (acc.stylist[t.EmployeeName] || 0) + t.CommissionAmount;
                        if (t.Role === 'Operator') acc.operators[t.EmployeeName] = (acc.operators[t.EmployeeName] || 0) + t.CommissionAmount;
                        return acc;
                      }, { totalSales: 0, totalCommission: 0, stylist: {}, operators: {} });
                      

                      const groupedByDate = filteredTransactions.reduce((acc, t) => {
                        const date = t.TransactionDate;
                        if (!acc[date]) acc[date] = {};
                        if (!acc[date][t.SaleID]) acc[date][t.SaleID] = [];
                        acc[date][t.SaleID].push(t);
                        return acc;
                      }, {});

                      return (
                        <div className="space-y-4">
                          <div className="bg-white rounded-lg shadow-md overflow-hidden">
                            <table className="w-full text-sm">
                              <thead>
                                <tr className="bg-gradient-to-r from-slate-100 to-slate-200 border-b-2 border-slate-300">
                                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wide">Date</th>
                                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wide">Name</th>
                                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wide">Rule</th>
                                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase">
                                      Commission Type
                                    </th>
                                  <th className="px-4 py-3 text-right text-xs font-semibold text-slate-600 uppercase tracking-wide">Sales</th>
                                  <th className="px-4 py-3 text-right text-xs font-semibold text-slate-600 uppercase tracking-wide">Commission</th>
                                  <th className="px-4 py-3 text-right text-xs font-semibold text-slate-600 uppercase tracking-wide">Split</th>
                                </tr>
                              </thead>
                              <tbody>
                                {Object.entries(groupedByDate).map(([date, rows]) => (
                                  <React.Fragment key={date}>
                                    <tr className="bg-gradient-to-r from-cyan-100 to-blue-100 border-b border-slate-200">
                                      <td colSpan={6} className="px-4 py-2.5 font-bold text-slate-700 flex items-center gap-2">
                                        <span>📅</span>
                                        {date}
                                      </td>
                                    </tr>

                                    {Object.entries(rows).map(([saleId, saleRows]) => {
                                     const parents = saleRows.filter(r => r.Role === 'Stylist');
                                  const children = saleRows.filter(r => r.Role === 'Operator');

                                  return (
                                    <React.Fragment key={saleId}>

                                      {/* ✅ Render ALL stylist rows */}
                                      {parents.map(parent => (
                                        <tr key={parent.HistoryID} className="border-b border-slate-100 hover:bg-slate-50 transition-colors">
                                          <td className="px-4 py-2.5 text-slate-600">{parent.TransactionDate}</td>

                                          <td className="px-4 py-2.5 font-semibold text-slate-800">
                                            {parent.ItemName || 'Uncategorized'}
                                          </td>

                                          <td className="px-4 py-2.5">
                                            <span className="px-2 py-1 bg-indigo-100 text-indigo-700 text-xs font-semibold rounded">
                                              {parent.RuleName}
                                            </span>
                                          </td>

                                          <td className="px-4 py-2.5 text-slate-600 text-xs">
                                            {formatCommissionType(parent)}
                                          </td>

                                          <td className="px-4 py-2.5 text-right font-medium text-slate-700">
                                            {formatMoney(parent.TotalSalesExTax)}
                                          </td>

                                          <td className="px-4 py-2.5 text-right font-bold text-green-600">
                                            {formatMoney(parent.CommissionAmount)}
                                          </td>

                                          <td className="px-4 py-2.5 text-right text-slate-500 text-xs">
                                            {parent.SplitInfo || '—'}
                                          </td>
                                        </tr>
                                      ))}

                                      {/* Operators (unchanged) */}
                                      {showOperatorsInline && children.map(child => (
                                        <tr key={child.HistoryID} className="border-b border-slate-100 bg-emerald-50/30 hover:bg-emerald-50 transition-colors">
                                          <td></td>

                                          <td className="px-4 py-2.5 pl-10">
                                            <div className="flex items-center gap-2">
                                              <span className="text-xs px-2 py-0.5 bg-emerald-500 text-white rounded-full font-bold shadow-sm">
                                                OP
                                              </span>
                                              <span className="text-slate-700 italic">{child.EmployeeName}</span>
                                            </div>
                                          </td>

                                          <td className="px-4 py-2.5">
                                            <span className="px-2 py-1 bg-emerald-100 text-emerald-700 text-xs font-semibold rounded">
                                              {child.RuleName}
                                            </span>
                                          </td>

                                          <td className="px-4 py-2.5 text-slate-600 text-xs">
                                            {formatCommissionType(child)}
                                          </td>

                                          <td className="px-4 py-2.5 text-right text-slate-600">
                                            {formatMoney(child.TotalSalesExTax)}
                                          </td>

                                          <td className="px-4 py-2.5 text-right font-bold text-emerald-600">
                                            {formatMoney(child.CommissionAmount)}
                                          </td>

                                          <td className="px-4 py-2.5 text-right text-slate-500 text-xs">
                                            {child.SplitInfo || '—'}
                                          </td>
                                        </tr>
                                      ))}

                                    </React.Fragment>
                                  );
                                    })}
                                  </React.Fragment>
                                ))}
                              </tbody>
                            </table>
                          </div>

                          {/* Operator Cards (when not inline) */}
                          {!showOperatorsInline && (() => {
                            const operators = [...new Set(filteredTransactions.filter(t => t.Role === 'Operator').map(t => t.EmployeeName))];
                            return operators.length > 0 && (
                              <div className="space-y-3">
                                <h4 className="text-sm font-bold text-slate-700 uppercase tracking-wide flex items-center gap-2">
                                  <span>👥</span> Operator Commissions
                                </h4>
                                {operators.map(opName => {
                                  const operatorTx = filteredTransactions.filter(t => t.Role === 'Operator' && t.EmployeeName === opName);
                                  const operatorTotals = operatorTx.reduce((acc, t) => {
                                    acc.sales += t.TotalSalesExTax;
                                    acc.commission += t.CommissionAmount;
                                    return acc;
                                  }, { sales: 0, commission: 0 });

                                  return (
                                    <div key={opName} className="border-2 border-emerald-200 rounded-xl bg-white overflow-hidden shadow-sm">
                                      <div
                                        onClick={() => toggleOperator(opName)}
                                        className="cursor-pointer px-4 py-3 bg-gradient-to-r from-emerald-50 to-green-50 flex justify-between items-center hover:from-emerald-100 hover:to-green-100 transition-all"
                                      >
                                        <div className="flex items-center gap-3">
                                          <span className={`transition-transform duration-200 text-emerald-600 ${expandedOperators[opName] ? 'rotate-90' : ''}`}>
                                            ▶
                                          </span>
                                          <span className="font-bold text-emerald-800 flex items-center gap-2">
                                            <span>👤</span>
                                            {opName}
                                          </span>
                                        </div>
                                        <span className="px-3 py-1 bg-gradient-to-r from-emerald-500 to-green-600 text-white font-bold rounded-lg shadow-sm">
                                          {formatMoney(operatorTotals.commission)}
                                        </span>
                                      </div>

                                      {expandedOperators[opName] && (
                                        <div className="p-4 bg-emerald-50/30">
                                          <table className="w-full text-sm">
                                            <thead>
                                              <tr className="border-b-2 border-emerald-200">
                                                <th className="px-2 py-2 text-left text-xs font-semibold text-slate-600">Date</th>
                                                <th className="px-2 py-2 text-left text-xs font-semibold text-slate-600">Item</th>
                                                <th className="px-2 py-2 text-left text-xs font-semibold text-slate-600">
                                                  Commission Type
                                                </th>
                                                <th className="px-2 py-2 text-right text-xs font-semibold text-slate-600">Sales</th>
                                                <th className="px-2 py-2 text-right text-xs font-semibold text-slate-600">Commission</th>
                                                <th className="px-2 py-2 text-right text-xs font-semibold text-slate-600">Split</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {operatorTx.map((t, i) => (
                                                <tr key={i} className="border-b border-emerald-100 hover:bg-white transition-colors">
                                                  <td className="px-2 py-2 text-slate-600">{t.TransactionDate}</td>
                                                  <td className="px-2 py-2 text-slate-700">{t.ItemName}</td>
                                                   <td className="px-2 py-2 text-xs text-slate-600">
                                                      {formatCommissionType(t)}
                                                    </td>
                                                  <td className="px-2 py-2 text-right text-slate-700">{formatMoney(t.TotalSalesExTax)}</td>
                                                  <td className="px-2 py-2 text-right font-bold text-emerald-600">{formatMoney(t.CommissionAmount)}</td>
                                                  <td className="px-2 py-2 text-right text-slate-500 text-xs">{t.SplitInfo || '—'}</td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                        </div>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            );
                          })()}

                          {/* Totals Summary */}
                          <div className="bg-white rounded-xl shadow-md p-5 border-2 border-slate-200">
                            <h4 className="text-sm font-bold text-slate-700 uppercase tracking-wide mb-4">Commission Summary</h4>
                            <div className="space-y-3">
                              <div className="flex justify-between items-center pb-3 border-b border-slate-200">
                                <span className="text-sm font-semibold text-slate-600">Total Sales</span>
                                <span className="text-lg font-bold text-slate-800">{formatMoney(s.TotalSalesExTax)}</span>
                              </div>
                              <div className="flex justify-between items-center pb-3 border-b-2 border-green-200">
                                <span className="text-sm font-semibold text-slate-600">Total Commission</span>
                                <span className="text-xl font-bold bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent">
                                  {totals.totalCommission.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </span>
                              </div>
                              {Object.entries(totals.stylist).map(([name, amt]) => (
                                <div key={name} className="flex justify-between items-center text-sm pl-4">
                                  <span className="text-slate-600">💼 Stylist — {name}</span>
                                  <span className="font-bold text-blue-600">{amt.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                </div>
                              ))}

                              {Object.entries(totals.operators).map(([name, amt]) => (
                                <div key={name} className="flex justify-between items-center text-sm pl-4">
                                  <span className="text-emerald-700">👤 Operator — {name}</span>
                                  <span className="font-bold text-emerald-600">{amt.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      );
                    })()}
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))
        )}
      </tbody>
    </table>
  </div>



      {/* Modal */}
{showRuleModal && (
  <div className="fixed inset-0 z-50 flex justify-end">
    {/* Backdrop */}
    <div
      className="absolute inset-0 bg-black/60 backdrop-blur-sm"
      onClick={() => setShowRuleModal(false)}
    />

    {/* Modal Panel */}
    <div className="relative w-full max-w-4xl bg-gradient-to-br from-slate-50 to-white overflow-y-auto shadow-2xl">
      {/* Header */}
      
      <div className="sticky top-0 bg-gradient-to-r from-cyan-600 to-blue-600 px-8 py-5 flex justify-between items-center shadow-lg z-10">

        {/* Title */}
        <h2 className="text-2xl font-bold text-white flex items-center gap-3">

          {modalMode === 'manage' && (
            <>
              <span className="text-2xl">⚙️</span>
              <span>Manage Commission Rules</span>
            </>
          )}

          {modalMode === 'edit' && (
            <>
              <span className="text-2xl">✏️</span>
              <span>Edit Commission Rule</span>
            </>
          )}

          {modalMode === 'add' && (
            <>
              <span className="text-2xl">➕</span>
              <span>Add Commission Rule</span>
            </>
          )}

        </h2>

        {/* Right side buttons */}
        <div className="flex items-center gap-2">

          {/* Back button — ONLY in Edit mode */}
          {modalMode === 'edit' && (
            <button
              onClick={() => {
                setModalMode('manage');
                setEditingRule(null);
              }}
              className="text-white hover:bg-white/20 rounded-full px-3 py-2 transition-all duration-200 flex items-center gap-2"
            >
              <span className="text-lg">←</span>
              <span className="font-semibold hidden sm:inline">Manage</span>
            </button>
          )}

          {/* Close button */}
          <button
            className="text-white hover:bg-white/20 rounded-full p-2.5 transition-all duration-200 hover:rotate-90"
            onClick={() => setShowRuleModal(false)}
          >
            <span className="text-2xl font-light">✕</span>
          </button>

        </div>

      </div>

      {/* Content */}
      <div className="p-8 space-y-8">
        {modalMode === 'manage' ? (
          /* ========== MANAGE MODE ========== */
          <div className="space-y-6">
            {/* Toggle Inactive Rules */}
            <label className="flex items-center gap-4 p-5 bg-white rounded-xl border-2 border-slate-200 cursor-pointer hover:border-cyan-400 hover:shadow-md transition-all">
              <input
                type="checkbox"
                checked={showInactiveRules}
                onChange={e => setShowInactiveRules(e.target.checked)}
                className="w-5 h-5 text-cyan-600 rounded focus:ring-2 focus:ring-cyan-400"
              />
              <div className="flex-1">
                <div className="font-semibold text-slate-800">Show inactive rules</div>
                <p className="text-sm text-slate-500">Display deactivated commission rules</p>
              </div>
            </label>
            {/* Search Bar + Add Rule */}
                <div className="flex flex-col sm:flex-row gap-3">

                  {/* Search Input */}
                  <div className="relative flex-1">
                    <input
                      type="text"
                      placeholder="Search commission rules..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="w-full px-5 py-3 pl-11 border-2 border-slate-200 rounded-xl focus:border-cyan-500 focus:ring-2 focus:ring-cyan-200 outline-none transition-all"
                    />

                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-lg">
                      🔍
                    </span>

                    {searchTerm && (
                      <button
                        onClick={() => setSearchTerm('')}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-red-500 text-lg"
                      >
                        ✕
                      </button>
                    )}
                  </div>

                  {/* Add Rule Button */}
                  {/* <button
                    onClick={() => {
                      setEditingRule(null);
                      setModalMode('add');
                    }}
                    className="
                      px-6 py-3
                      bg-gradient-to-r from-blue-500 to-blue-600
                      text-white font-semibold
                      rounded-xl
                      hover:shadow-lg
                      transition-all duration-200
                      hover:scale-105
                      flex items-center gap-2
                      whitespace-nowrap
                    "
                  >
                    <span className="text-lg">➕</span>
                    Add Rule
                  </button> */}

                </div>
            {/* Rules List */}
            <div className="space-y-4">
              {filteredRules.map(rule => (
                <div
                  key={rule.CommissionRuleId}
                  className={`p-6 border-2 rounded-xl transition-all duration-200 ${
                    rule.Active
                      ? 'bg-white border-slate-200 hover:border-cyan-400 hover:shadow-lg'
                      : 'bg-slate-50 border-slate-300 opacity-70'
                  }`}
                >
                  <div className="flex justify-between items-center">
                    <div className="flex items-center gap-3">
                      <span className="text-lg font-bold text-slate-800">{rule.Name}</span>
                      {!rule.Active && (
                        <span className="px-3 py-1 text-xs font-semibold bg-red-100 text-red-700 rounded-full border border-red-200">
                          INACTIVE
                        </span>
                      )}
                    </div>

                    <div className="flex gap-3">
                      {rule.Active ? (
                        <>
                          <button
                            onClick={() => openEditRuleModal(rule)}
                            className="px-5 py-2.5 bg-gradient-to-r from-blue-500 to-blue-600 text-white text-sm font-semibold rounded-lg hover:shadow-lg transition-all duration-200 hover:scale-105"
                          >
                            ✏️ Edit
                          </button>
                          <button
                            onClick={() => deactivateRule(rule)}
                            className="px-5 py-2.5 bg-gradient-to-r from-red-500 to-red-600 text-white text-sm font-semibold rounded-lg hover:shadow-lg transition-all duration-200 hover:scale-105"
                          >
                            🚫 Deactivate
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            onClick={() => restoreRule(rule)}
                            className="px-5 py-2.5 bg-gradient-to-r from-green-500 to-green-600 text-white text-sm font-semibold rounded-lg hover:shadow-lg transition-all duration-200 hover:scale-105"
                          >
                            ♻️ Restore
                          </button>
                          <button
                            onClick={() => hardDeleteRule(rule)}
                            className="px-5 py-2.5 bg-gradient-to-r from-slate-700 to-slate-800 text-white text-sm font-semibold rounded-lg hover:shadow-lg transition-all duration-200 hover:scale-105"
                          >
                            🗑️ Delete
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              ))}
                {filteredRules.length === 0 && (
                  <div className="text-center text-slate-500 py-8">
                    No commission rules found
                  </div>
                )}
            </div>
          </div>
        ) : (
          /* ========== ADD/EDIT MODE ========== */
          <>
            {/* Rule Name */}
            <div className="bg-white p-6 rounded-xl border-2 border-slate-200 shadow-sm">
              <label className="block text-sm font-semibold text-slate-700 mb-3">
                📝 Rule Name
              </label>
              <input
                data-error-key="Name"
                className="w-full px-4 py-3 border-2 border-slate-300 rounded-lg focus:ring-2 focus:ring-cyan-400 focus:border-cyan-400 transition-all text-slate-800 font-medium"
                placeholder="Enter a descriptive rule name"
                value={ruleForm.Name}
                onChange={e => setRuleForm({ ...ruleForm, Name: e.target.value })}
              />
              {validationErrors.Name && (
                <p className="text-red-600 text-sm mt-2 font-medium flex items-center gap-2 bg-red-50 px-3 py-2 rounded-lg">
                  ⚠️ {validationErrors.Name}
                </p>
              )}
            </div>

            {/* Item Types Section */}
            <div>
              <div className="flex items-center gap-4 mb-6">
                <div className="h-px flex-1 bg-gradient-to-r from-transparent via-cyan-400 to-transparent"></div>
                <h3 className="text-sm font-bold text-slate-700 uppercase tracking-wider">
                  Item Configuration
                </h3>
                <div className="h-px flex-1 bg-gradient-to-r from-transparent via-cyan-400 to-transparent"></div>
              </div>

              {/* Items */}
              <div className="space-y-6">
                {ruleForm.Items.map((item, index) => (
                  <div
                    key={index}
                    className="bg-white border-2 border-slate-200 rounded-2xl shadow-sm hover:shadow-md transition-all"
                  >
                    {/* Item Header */}
                    <div className="flex items-center justify-between p-6 border-b-2 border-slate-100">
                      <div className="flex items-center gap-4">
                        <span className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-cyan-500 to-blue-500 text-white font-bold rounded-full shadow-md">
                          {index + 1}
                        </span>
                        <div>
                          <h4 className="font-semibold text-slate-800">Item Type {index + 1}</h4>
                          <p className="text-xs text-slate-500">Configure commission rules</p>
                        </div>
                      </div>
                      {ruleForm.Items.length > 1 && (
                        <button
                          onClick={() => {
                            const newItems = ruleForm.Items.filter((_, i) => i !== index);
                            setRuleForm({ ...ruleForm, Items: newItems });
                          }}
                          className="px-4 py-2 bg-red-500 text-white text-sm font-semibold rounded-lg hover:bg-red-600 transition-all"
                        >
                          🗑️ Remove
                        </button>
                      )}
                    </div>

                    {/* Item Body */}
                    <div className="p-6 space-y-5">
                      {/* Item Type Select */}
                      <div>
                        <label className="block text-xs font-semibold text-slate-600 mb-2 uppercase tracking-wide">
                          Select Item Type
                        </label>
                        <div data-error-key={`Items.${index}.ItemType`}>
                          <Select
                            options={itemTypeOptions.filter(opt =>
                              !ruleForm.Items.some((i, idx) => i.ItemType === opt.value && idx !== index)
                            )}
                            value={itemTypeOptions.find(o => o.value === item.ItemType)}
                            onChange={async sel => {
                              const newItems = [...ruleForm.Items];
                              newItems[index].ItemType = sel.value;
                              newItems[index].Percent = null;
                              newItems[index].CategoryFilter = [];
                              newItems[index].CategoryFilterOptions = await fetchCategoriesForItemType(sel.value);
                              setRuleForm({ ...ruleForm, Items: newItems });
                            }}
                            placeholder="Choose an item type..."
                            styles={{
                              control: base => ({
                                ...base,
                                borderColor: '#cbd5e1',
                                borderWidth: '2px',
                                '&:hover': { borderColor: '#06b6d4' },
                                minHeight: '48px',
                              }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected ? '#06b6d4' : state.isFocused ? '#ecfeff' : 'white',
                              }),
                            }}
                          />
                        </div>
                        {validationErrors[`Items.${index}.ItemType`] && (
                          <p className="text-red-600 text-sm mt-2 font-medium bg-red-50 px-3 py-2 rounded-lg">
                            ⚠️ {validationErrors[`Items.${index}.ItemType`]}
                          </p>
                        )}
                      </div>

                      {/* Service Categories */}
                      {item.ItemType === 1 && (
                        <div className="p-5 bg-cyan-50 rounded-xl border-2 border-cyan-200">
                          <label className="flex items-center gap-3 mb-4 cursor-pointer">
                            <input
                              type="checkbox"
                              checked={item.ApplyAllCategories || false}
                              onChange={e => {
                                const newItems = [...ruleForm.Items];
                                const checked = e.target.checked;
                                newItems[index].ApplyAllCategories = checked;
                                 // Option 2: leave CategoryFilter empty
                                newItems[index].CategoryFilter = [];
                                setRuleForm({ ...ruleForm, Items: newItems });
                              }}
                              className="w-5 h-5 text-cyan-600 rounded focus:ring-2 focus:ring-cyan-400"
                            />
                            <div>
                              <span className="font-semibold text-slate-800">Apply to all service categories</span>
                              <p className="text-xs text-slate-600">This rule will apply to every service category</p>
                            </div>
                          </label>

                          <div>
                            <label className="block text-xs font-semibold text-cyan-700 mb-2">
                              Select Categories
                            </label>
                            <input
                              type="text"
                              placeholder="Search categories..."
                              value={categorySearch[index] || ''}
                              onChange={e => setCategorySearch(prev => ({ ...prev, [index]: e.target.value }))}
                              className="w-full mb-3 px-4 py-2.5 border-2 border-cyan-300 rounded-lg focus:ring-2 focus:ring-cyan-400 text-sm"
                            />
                            <div
                              data-error-key={`Items.${index}.CategoryFilter`}
                              className="max-h-64 overflow-y-auto bg-white border-2 border-cyan-200 rounded-lg divide-y divide-slate-100"
                            >
                              {(item.CategoryFilterOptions || [])
                                .filter(opt =>
                                  !membershipCategoriesInRule.includes(opt.value) &&
                                  !promotionCategoriesInRule.includes(opt.value)
                                )
                                .filter(opt =>
                                  opt.label.toLowerCase().includes((categorySearch[index] || '').toLowerCase())
                                )
                                .map(opt => {
                                   const isSelected = item.ApplyAllCategories || item.CategoryFilter?.includes(opt.value);

                                  return (
                                    <div
                                      key={opt.value}
                                      onClick={() => {
  const newItems = [...ruleForm.Items];
  const current = newItems[index].CategoryFilter || [];

  // If ApplyAllCategories is true, initialize CategoryFilter with all options first
  if (newItems[index].ApplyAllCategories) {
    newItems[index].CategoryFilter = (item.CategoryFilterOptions || [])
      .map(opt => opt.value);
  }

  // Toggle this category
  const alreadySelected = newItems[index].CategoryFilter.includes(opt.value);
  newItems[index].CategoryFilter = alreadySelected
    ? newItems[index].CategoryFilter.filter(v => v !== opt.value)
    : [...newItems[index].CategoryFilter, opt.value];

  // Once user manually edits, remove Apply All
  newItems[index].ApplyAllCategories = false;

  setRuleForm({ ...ruleForm, Items: newItems });
}}
                                      className={`px-4 py-3 cursor-pointer transition-all ${
                                        isSelected
                                          ? 'bg-cyan-100 text-cyan-900 font-semibold'
                                          : 'hover:bg-cyan-50 text-slate-700'
                                      }`}
                                    >
                                      <div className="flex items-center justify-between">
                                        <span>{opt.label}</span>
                                        {isSelected && <span className="text-cyan-600 font-bold">✔</span>}
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                          {validationErrors[`Items.${index}.CategoryFilter`] && (
                            <p className="text-red-600 text-sm mt-2 font-medium bg-red-50 px-3 py-2 rounded-lg">
                              ⚠️ {validationErrors[`Items.${index}.CategoryFilter`]}
                            </p>
                          )}
                        </div>
                      )}

                      {/* Membership & Promotion Categories */}
                      {[7, 8].includes(item.ItemType) && (
                        <div className={`p-5 rounded-xl border-2 ${
                          item.ItemType === 7
                            ? 'bg-green-50 border-green-200'
                            : 'bg-orange-50 border-orange-200'
                        }`}>
                          <label className={`block font-semibold mb-3 ${
                            item.ItemType === 7 ? 'text-green-800' : 'text-orange-800'
                          }`}>
                            {item.ItemType === 7 ? '🎫 Membership Categories' : '🏷️ Promotion Categories'}
                          </label>
                          <input
                            type="text"
                            placeholder="Search categories..."
                            value={categorySearch[index] || ''}
                            onChange={e => setCategorySearch(prev => ({ ...prev, [index]: e.target.value }))}
                            className={`w-full mb-3 px-4 py-2.5 border-2 rounded-lg focus:ring-2 text-sm ${
                              item.ItemType === 7
                                ? 'border-green-300 focus:ring-green-400'
                                : 'border-orange-300 focus:ring-orange-400'
                            }`}
                          />
                          <div
                            data-error-key={`Items.${index}.CategoryFilter`}
                            className={`max-h-64 overflow-y-auto bg-white border-2 rounded-lg divide-y divide-slate-100 ${
                              item.ItemType === 7 ? 'border-green-200' : 'border-orange-200'
                            }`}
                          >
                            {(item.CategoryFilterOptions || [])
                              .filter(opt =>
                                !serviceCategoriesInRule.includes(opt.value) &&
                                (item.ItemType === 7
                                  ? !promotionCategoriesInRule.includes(opt.value)
                                  : !membershipCategoriesInRule.includes(opt.value))
                              )
                              .filter(opt =>
                                opt.label.toLowerCase().includes((categorySearch[index] || '').toLowerCase())
                              )
                              .map(opt => {
                                const isSelected = item.CategoryFilter?.includes(opt.value);
                                return (
                                  <div
                                    key={opt.value}
                                    onClick={() => {
                                      const newItems = [...ruleForm.Items];
                                      const current = newItems[index].CategoryFilter || [];
                                      newItems[index].CategoryFilter = isSelected
                                        ? current.filter(v => v !== opt.value)
                                        : [...current, opt.value];
                                      setRuleForm({ ...ruleForm, Items: newItems });
                                    }}
                                    className={`px-4 py-3 cursor-pointer transition-all ${
                                      isSelected
                                        ? item.ItemType === 7
                                          ? 'bg-green-100 text-green-900 font-semibold'
                                          : 'bg-orange-100 text-orange-900 font-semibold'
                                        : item.ItemType === 7
                                          ? 'hover:bg-green-50'
                                          : 'hover:bg-orange-50'
                                    }`}
                                  >
                                    <div className="flex items-center justify-between">
                                      <span>{opt.label}</span>
                                      {isSelected && <span className="font-bold">✔</span>}
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                          {validationErrors[`Items.${index}.CategoryFilter`] && (
                            <p className="text-red-600 text-sm mt-2 font-medium bg-red-50 px-3 py-2 rounded-lg">
                              ⚠️ {validationErrors[`Items.${index}.CategoryFilter`]}
                            </p>
                          )}
                        </div>
                      )}

                      {/* Retail Companies */}
                      {item.ItemType === 2 && (
                        <div className="p-5 bg-blue-50 rounded-xl border-2 border-blue-200">
                          <label className="flex items-center gap-3 mb-4 cursor-pointer">
                            <input
                              type="checkbox"
                              checked={item.ApplyAllCompanies || false}
                              onChange={e => {
                                const newItems = [...ruleForm.Items];
                                const checked = e.target.checked;
                                newItems[index].ApplyAllCompanies = checked;
                                if (checked) {
                                  newItems[index].CompanyFilter = (item.CompanyFilterOptions || []).map(opt => opt.value);
                                } else {
                                  newItems[index].CompanyFilter = [];
                                }
                                setRuleForm({ ...ruleForm, Items: newItems });
                              }}
                              className="w-5 h-5 text-blue-600 rounded focus:ring-2 focus:ring-blue-400"
                            />
                            <div>
                              <span className="font-semibold text-slate-800">Apply to all retail companies</span>
                              <p className="text-xs text-slate-600">This rule will apply to every retail company</p>
                            </div>
                          </label>

                          <div>
                            <label className="block text-xs font-semibold text-blue-700 mb-2">
                              Select Companies
                            </label>
                            <input
                              type="text"
                              placeholder="Search companies..."
                              value={companySearch[index] || ''}
                              onChange={e => setCompanySearch(prev => ({ ...prev, [index]: e.target.value }))}
                              className="w-full mb-3 px-4 py-2.5 border-2 border-blue-300 rounded-lg focus:ring-2 focus:ring-blue-400 text-sm"
                            />
                            <div
                              data-error-key={`Items.${index}.CompanyFilter`}
                              className="max-h-64 overflow-y-auto bg-white border-2 border-blue-200 rounded-lg divide-y divide-slate-100"
                            >
                              {(item.CompanyFilterOptions || [])
                                .filter(opt =>
                                  opt.label.toLowerCase().includes((companySearch[index] || '').toLowerCase())
                                )
                                .map(opt => {
                                  const isSelected = item.CompanyFilter?.includes(opt.value);
                                  return (
                                    <div
                                      key={opt.value}
                                      onClick={() => {
                                        const newItems = [...ruleForm.Items];
                                        const current = newItems[index].CompanyFilter || [];
                                        newItems[index].CompanyFilter = isSelected
                                          ? current.filter(v => v !== opt.value)
                                          : [...current, opt.value];
                                        newItems[index].ApplyAllCompanies = false;
                                        setRuleForm({ ...ruleForm, Items: newItems });
                                      }}
                                      className={`px-4 py-3 cursor-pointer transition-all ${
                                        isSelected
                                          ? 'bg-blue-100 text-blue-900 font-semibold'
                                          : 'hover:bg-blue-50 text-slate-700'
                                      }`}
                                    >
                                      <div className="flex items-center justify-between">
                                        <span>{opt.label}</span>
                                        {isSelected && <span className="text-blue-600 font-bold">✔</span>}
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                          {validationErrors[`Items.${index}.CompanyFilter`] && (
                            <p className="text-red-600 text-sm mt-2 font-medium bg-red-50 px-3 py-2 rounded-lg">
                              ⚠️ {validationErrors[`Items.${index}.CompanyFilter`]}
                            </p>
                          )}
                        </div>
                      )}

                      {/* Split Payment */}
                      <div className="p-5 bg-purple-50 rounded-xl border-2 border-purple-200">
                        <label className="flex items-center gap-3 mb-4 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={item.SplitEnabled}
                            onChange={e => {
                              const newItems = [...ruleForm.Items];
                              newItems[index].SplitEnabled = e.target.checked;
                              if (e.target.checked && newItems[index].SplitRatio == null) {
                                newItems[index].SplitRatio = 50;
                              }
                              setRuleForm({ ...ruleForm, Items: newItems });
                            }}
                            className="w-5 h-5 text-purple-600 rounded focus:ring-2 focus:ring-purple-400"
                          />
                          <div>
                            <span className="font-semibold text-slate-800">Enable Split Payment</span>
                            <p className="text-xs text-slate-600">Divide commission between stylist and operator</p>
                          </div>
                        </label>
                        {item.SplitEnabled && (
                          <div className="bg-white p-4 rounded-lg border border-purple-200">
                            <label className="block text-xs font-semibold text-purple-700 mb-2 uppercase">
                              Stylist Percentage
                            </label>
                            <input
                              data-error-key={`Items.${index}.SplitRatio`}
                              type="number"
                              inputMode="decimal"
                              min={0}
                              max={100}
                              value={item.SplitRatio ?? ''}
                              onChange={e => {
                                const newItems = [...ruleForm.Items];
                                newItems[index].SplitRatio = e.target.value === '' ? '' : Number(e.target.value);
                                setRuleForm({ ...ruleForm, Items: newItems });
                              }}
                              onWheel={e => e.target.blur()}
                              className="w-full px-4 py-3 border-2 border-purple-300 rounded-lg focus:ring-2 focus:ring-purple-400 font-bold text-purple-700"
                            />
                            <div className="mt-3 flex items-center justify-between bg-purple-100 px-4 py-3 rounded-lg">
                              <span className="text-sm font-semibold text-purple-700">Operator Percentage</span>
                              <span className="text-lg font-bold text-purple-700">{100 - (item.SplitRatio || 0)}%</span>
                            </div>
                            {validationErrors[`Items.${index}.SplitRatio`] && (
                              <p className="text-red-600 text-sm mt-2 font-medium bg-red-50 px-3 py-2 rounded-lg">
                                ⚠️ {validationErrors[`Items.${index}.SplitRatio`]}
                              </p>
                            )}
                          </div>
                        )}
                      </div>

                      {/* Commission Method */}
                      <div>
                        <label className="block text-xs font-semibold text-slate-600 mb-3 uppercase tracking-wide">
                          Commission Method
                        </label>
                        <div className="space-y-3">
                          <label className="flex items-center gap-3 p-4 bg-white border-2 border-slate-200 rounded-lg cursor-pointer hover:border-cyan-400 transition-all">
                            <input
                              type="radio"
                              name={`commissionMethod-${index}`}
                              checked={item.CommissionMethod === 1}
                              onChange={() => {
                                const newItems = [...ruleForm.Items];
                                newItems[index].CommissionMethod = 1;
                                newItems[index].SlabDefinition = [];
                                setRuleForm({ ...ruleForm, Items: newItems });
                              }}
                              className="w-4 h-4 text-cyan-600"
                            />
                            <div>
                              <span className="font-semibold text-slate-800">💯 Fixed Percentage</span>
                              <p className="text-xs text-slate-500">Apply a single commission rate</p>
                            </div>
                          </label>

                          <label className="flex items-center gap-3 p-4 bg-white border-2 border-slate-200 rounded-lg cursor-pointer hover:border-indigo-400 transition-all">
                            <input
                              type="radio"
                              name={`commissionMethod-${index}`}
                              checked={item.CommissionMethod === 2}
                              onChange={() => {
                                const newItems = [...ruleForm.Items];
                                newItems[index].CommissionMethod = 2;
                                if (!newItems[index].SlabDefinition.length) {
                                  newItems[index].SlabDefinition = [{ Min: 0, Max: '', Percent: '' }];
                                }
                                setRuleForm({ ...ruleForm, Items: newItems });
                              }}
                              className="w-4 h-4 text-indigo-600"
                            />
                            <div>
                              <span className="font-semibold text-slate-800">📊 Progressive Slab</span>
                              <p className="text-xs text-slate-500">Commission increases with amount ranges</p>
                            </div>
                          </label>

                          <label className="flex items-center gap-3 p-4 bg-white border-2 border-slate-200 rounded-lg cursor-pointer hover:border-purple-400 transition-all">
                            <input
                              type="radio"
                              name={`commissionMethod-${index}`}
                              checked={item.CommissionMethod === 3}
                              onChange={() => {
                                const newItems = [...ruleForm.Items];
                                newItems[index].CommissionMethod = 3;
                                if (!newItems[index].SlabDefinition.length) {
                                  newItems[index].SlabDefinition = [{ Min: 0, Max: '', Percent: '' }];
                                }
                                setRuleForm({ ...ruleForm, Items: newItems });
                              }}
                              className="w-4 h-4 text-purple-600"
                            />
                            <div>
                              <span className="font-semibold text-slate-800">🚀 Flat Slab (Jump Slab)</span>
                              <p className="text-xs text-slate-500">Commission jumps at threshold amounts</p>
                            </div>
                          </label>
                        </div>
                      </div>

                      {/* Fixed Percentage or Slabs */}
                      {item.CommissionMethod === 1 ? (
                        <div>
                          <label className="block text-xs font-semibold text-slate-600 mb-2 uppercase">
                            Commission Percentage
                          </label>
                          <div className="relative">
                            <input
                              data-error-key={`Items.${index}.Percent`}
                              type="number"
                              inputMode="decimal"
                              value={item.Percent === 0 ? '' : item.Percent}
                              onChange={e => {
                                const newItems = [...ruleForm.Items];
                                newItems[index].Percent = e.target.value === '' ? '' : Number(e.target.value);
                                setRuleForm({ ...ruleForm, Items: newItems });
                              }}
                              onWheel={e => e.target.blur()}
                              placeholder="Enter percentage (e.g., 10)"
                              className="w-full px-4 py-3 pr-12 border-2 border-slate-300 rounded-lg focus:ring-2 focus:ring-cyan-400 font-bold text-slate-700"
                            />
                            <span className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 font-bold text-lg">%</span>
                          </div>
                          {validationErrors[`Items.${index}.Percent`] && (
                            <p className="text-red-600 text-sm mt-2 font-medium bg-red-50 px-3 py-2 rounded-lg">
                              ⚠️ {validationErrors[`Items.${index}.Percent`]}
                            </p>
                          )}
                        </div>
                      ) : (
                        <div className="p-5 bg-indigo-50 rounded-xl border-2 border-indigo-200">
                          <label className="block font-semibold text-indigo-800 mb-4">
                            📊 {item.CommissionMethod === 2 ? 'Progressive Commission Slabs' : 'Flat (Jump) Commission Slabs'}
                          </label>

                          <div className="grid grid-cols-4 gap-3 mb-3 text-xs font-semibold text-indigo-700 uppercase">
                            <span className="text-center">Min Amount</span>
                            <span className="text-center">Max Amount</span>
                            <span className="text-center">Percent %</span>
                            <span className="text-center">Action</span>
                          </div>

                          <div data-error-key={`Items.${index}.SlabDefinition`} className="space-y-2">
                            {item.SlabDefinition.map((s, i) => {
                              const isLast = i === item.SlabDefinition.length - 1;
                              const canDelete = isLast && item.SlabDefinition.length > 1;

                              return (
                                <div key={i} className="grid grid-cols-4 gap-3 items-center">
                                  <input
                                    value={s.Min}
                                    disabled={i > 0}
                                    onChange={e => {
                                      if (i === 0) {
                                        updateSlab(index, i, 'Min', e.target.value);
                                      }
                                    }}
                                    className="px-3 py-3 border-2 border-indigo-300 rounded-lg text-center bg-slate-100 font-semibold"
                                  />
                                  <input
                                    value={s.Max}
                                    onChange={e => updateSlab(index, i, 'Max', e.target.value)}
                                    placeholder="Max"
                                    className="px-3 py-3 border-2 border-indigo-300 rounded-lg text-center focus:ring-2 focus:ring-indigo-400 font-semibold"
                                  />
                                  <input
                                    value={s.Percent}
                                    onChange={e => updateSlab(index, i, 'Percent', e.target.value)}
                                    placeholder="%"
                                    className="px-3 py-3 border-2 border-indigo-300 rounded-lg text-center focus:ring-2 focus:ring-indigo-400 font-semibold"
                                  />
                                  {canDelete ? (
                                    <button
                                      type="button"
                                      onClick={() => removeLastSlab(index)}
                                      className="px-3 py-3 bg-red-500 text-white rounded-lg font-bold hover:bg-red-600 transition"
                                      title="Remove last slab"
                                    >
                                      🗑
                                    </button>
                                  ) : (
                                    <div />
                                  )}
                                </div>
                              );
                            })}
                          </div>

                          {validationErrors[`Items.${index}.SlabDefinition`] && (
                            <p className="text-red-600 text-sm mt-3 font-medium bg-red-50 px-3 py-2 rounded-lg">
                              ⚠️ {validationErrors[`Items.${index}.SlabDefinition`]}
                            </p>
                          )}

                          <button
                            onClick={() => addSlab(index)}
                            className="w-full mt-4 px-4 py-3 bg-white border-2 border-dashed border-indigo-400 text-indigo-700 font-semibold rounded-lg hover:bg-indigo-50 transition-all"
                          >
                            + Add New Slab
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Add Another Item Button */}
              <button
                disabled={!canAddMoreItems}
                onClick={() =>
                  setRuleForm(prev => ({
                    ...prev,
                    Items: [
                      ...prev.Items,
                      {
                        ItemType: null,
                        CommissionMethod: 1,
                        Percent: null,
                        SlabDefinition: [],
                        CategoryFilter: [],
                        CompanyFilter: [],
                        CategoryFilterOptions: [],
                        CompanyFilterOptions: retailCompanies,
                        SplitType: 1,
                        SplitRatio: 50,
                        ApplyAllCategories: false,
                        ApplyAllCompanies: false,
                      },
                    ],
                  }))
                }
                className={`w-full px-6 py-4 font-semibold rounded-xl transition-all border-2 border-dashed ${
                  canAddMoreItems
                    ? 'bg-white border-slate-400 text-slate-700 hover:border-cyan-500 hover:bg-cyan-50 hover:text-cyan-700'
                    : 'bg-slate-100 border-slate-300 text-slate-400 cursor-not-allowed'
                }`}
              >
                {hasUnconfiguredItem
                  ? '⚠️ Configure current item first'
                  : canAddMoreItems
                    ? '➕ Add Another Item Type'
                    : '✓ All Item Types Added'}
              </button>
            </div>

            {/* Global Employee Selection */}
            <div className="bg-white p-6 rounded-xl border-2 border-slate-200 shadow-sm">
              <label className="block text-sm font-semibold text-slate-700 mb-3">
                👥 Employees
              </label>
              <div data-error-key="EmployeeIds">
                <Select
                  isMulti
                  options={employees}
                  value={employees.filter(e => ruleForm.EmployeeIds.includes(e.value))}
                  onChange={sel => {
                    const ids = sel ? sel.map(s => s.value) : [];
                    setRuleForm(prev => ({ ...prev, EmployeeIds: ids }));
                  }}
                  placeholder="Select employees for this rule..."
                  styles={{
                    control: base => ({
                      ...base,
                      borderColor: '#cbd5e1',
                      borderWidth: '2px',
                      '&:hover': { borderColor: '#06b6d4' },
                      minHeight: '48px',
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isSelected ? '#06b6d4' : state.isFocused ? '#ecfeff' : 'white',
                    }),
                  }}
                />
              </div>
              {validationErrors.EmployeeIds && (
                <p className="text-red-600 text-sm mt-2 font-medium bg-red-50 px-3 py-2 rounded-lg">
                  ⚠️ {validationErrors.EmployeeIds}
                </p>
              )}
            </div>

            {/* Save Button */}
            <div className="flex justify-end pt-6 border-t-2 border-slate-200">
              <button
                onClick={saveRule}
                className="px-8 py-3.5 bg-gradient-to-r from-cyan-500 to-blue-600 text-white font-bold rounded-lg shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-200"
              >
                {editingRule ? '💾 Update Rule' : '✨ Create Rule'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  </div>
)}
    </div>
  );
};


export default Commissions;
